import React from 'react';
import HeaderSection from '../common/header/header';
import AutoSuggestSearchBar from './parts/SearchBar';
import HighlightSection from './parts/Highlights'
import MostPopularSection from './parts/MostPopular';
import FooterSection from '../common/footer/footer';
import NavBar from '../../components/navbar/navbar';
import * as navigation from '../../configs/navigation';
import * as translate from '../../assets/translations/translations';

class CommissionedResearch extends React.Component {
    constructor(props) {
        super(props);
        this.showSearchComponent = this.showSearchComponent.bind(this);
    }

    componentDidMount() {
        document.title = translate.strings.TR249
        try {
            //Below code is to reset the companyList array in session storage
            const getSessionParams = JSON.parse(sessionStorage.getItem('searchParams'))
            if (getSessionParams != null) {
                if (getSessionParams.companyList?.length == 14 && getSessionParams?.uncheckedAll == true) {
                    getSessionParams.companyList = []
                    getSessionParams.search = ""
                    getSessionParams.uncheckedAll = false
                    sessionStorage.setItem('searchParams', JSON.stringify(getSessionParams))
                }
            }

        } catch (error) {
        }
    }

    showSearchComponent = (value) => {
        document.getElementById("searchText").focus();
    }

    render() {
        return (
            <div>
                <HeaderSection showSearch={this.showSearchComponent} history={this.props.history} commr={true} />
                <NavBar items={navigation.commrNavInfo} commr={true} />
                <AutoSuggestSearchBar />
                <HighlightSection history={this.props.history} />
                {/* <MostPopularSection history={this.props.history} /> //currenct Most popular implementation does not suit the needs */}
                <FooterSection commr={true} />
            </div>
        )
    }
}

export default CommissionedResearch;